import React from 'react';
import { generateSectionId } from '@repo/ui-components/dept/utils/generateSectionId';
import ContactForm from '@repo/ui-components/dept/molecules/ContactForm';
import Image from '@repo/ui-components/tailwind/Image';
import { cn } from '@repo/tailwind-base/utils';
import type { SanityImage as SanityImageType } from '@repo/models/gatsby-graphql-types';

interface Props {
  block: {
    _key: string;
    _type: string;
    copy: string;
    headline: string;
    images: SanityImageType[];
  };
}

export default function FormPress({ block }: Readonly<Props>) {
  const { copy, headline, images } = block;

  const imageConfigs = [
    'w-[12.5rem] top-20 left-8 lg:w-[17.5rem] lg:top-0 lg:-left-4',
    'w-[6.1rem] top-8 right-[20%] lg:w-[8.75rem] lg:-top-4 lg:right-56',
    'w-[6.1rem] top-52 right-8 lg:w-[8.75rem] lg:top-32 lg:right-0',
    'w-[12.4rem] bottom-12 right-12 lg:w-[17.5rem] lg:-bottom-12 lg:right-32',
    'w-[6.1rem] bottom-48 left-8 lg:w-[8.75rem] lg:bottom-4 lg:-left-16',
  ];

  const svgData = `<svg
   width="1593.781"
   height="726"
   viewBox="0 0 1593.781 726"
   fill="none"
   version="1.1"
   id="svg311"
   sodipodi:docname="cloud-background.svg"
   inkscape:version="1.2.2 (b0a84865, 2022-12-01)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview470"
     pagecolor="#ffffff"
     bordercolor="#000000"
     borderopacity="0.25"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     showgrid="false"
     inkscape:zoom="0.27409988"
     inkscape:cx="798.97881"
     inkscape:cy="364.83051"
     inkscape:window-width="1309"
     inkscape:window-height="456"
     inkscape:window-x="0"
     inkscape:window-y="38"
     inkscape:window-maximized="0"
     inkscape:current-layer="g264" />
  <defs
     id="defs190" />
  <g
     clip-path="url(#clip0_3739_174516)"
     id="g264"
     transform="translate(44.000014,-74.999968)">
    <path
       opacity="0.4"
       d="m 1549.74,550.643 c -1.34,41.8 -35.63,74.573 -76.6,73.209 -1.52,-0.05 -3.02,-0.15 -4.51,-0.288 -1.91,0.075 -3.97,0.1 -6.15,0.05 -3.28,-0.1 -6.58,-0.188 -9.87,-0.275 -77.03,-2.116 -91.72,2.316 -168.72,-0.063 -2.17,-0.063 -4.33,-0.225 -6.5,-0.501 -49.61,-0.25 -70.54,2.479 -134.62,0.501 -24.66,-0.764 -42.49,-13.833 -52.35,-36.354 -13.82,-30.508 -0.3,-66.437 30.21,-80.257 6.83,-3.093 14.17,-4.895 21.65,-5.308 9.99,-45.556 50.56,-78.881 97.94,-77.303 25.7,0.876 49.98,12.03 67.36,30.971 35.89,-39.021 96.62,-41.575 135.64,-5.684 7.64,7.023 14.08,15.223 19.08,24.312 5.17,-0.964 10.44,-1.352 15.69,-1.177 40.96,1.352 73.1,36.354 71.75,78.167 z"
       fill="#c0dcfa"
       id="path182" />
    <path
       opacity="0.4"
       d="m 720.368,764.321 c -0.67,20.9 -17.813,37.287 -38.299,36.605 -0.758,-0.025 -1.509,-0.075 -2.253,-0.144 -0.958,0.038 -1.985,0.05 -3.074,0.025 -1.64,-0.05 -3.292,-0.094 -4.938,-0.138 -38.512,-1.058 -45.86,1.158 -84.36,-0.031 -1.083,-0.031 -2.166,-0.113 -3.248,-0.25 -24.805,-0.126 -35.27,1.239 -67.311,0.25 -12.33,-0.382 -21.243,-6.917 -26.175,-18.177 -6.91,-15.254 -0.15,-33.218 15.103,-40.129 3.418,-1.546 7.085,-2.447 10.828,-2.654 4.995,-22.777 25.281,-39.44 48.971,-38.651 12.85,0.438 24.987,6.015 33.68,15.485 17.945,-19.51 48.308,-20.787 67.818,-2.841 3.818,3.511 7.041,7.611 9.538,12.155 2.585,-0.482 5.221,-0.676 7.849,-0.588 20.48,0.676 36.547,18.177 35.871,39.083 z"
       fill="#c0dcfa"
       id="path184" />
    <path
       opacity="0.4"
       d="m 150.193,150.9907 c -0.804,25.0893 -21.383,44.7543 -45.965,43.9353 -0.909,-0.03 -1.81,-0.09 -2.704,-0.18 -1.149,0.045 -2.3885,0.06 -3.6953,0.023 -1.9753,-0.06 -3.9506,-0.113 -5.9334,-0.166 -46.2128,-1.269 -55.0302,1.39 -101.23543,-0.037 -14.79587,-0.458 -25.49097,-8.3 -31.40937,-21.814 -8.2917,-18.3059 -0.1728,-39.8719 18.1306,-48.1573 4.0933,-1.8554 8.502,-2.937 12.99337,-3.1849 5.99346,-27.3275 30.33533,-47.3311 58.76293,-46.3771 20.2787,0.7437 38.7022,12.0262 48.5861,29.7537 3.1095,-0.5784 6.2635,-0.8112 9.4185,-0.7061 24.582,0.8263 43.854,21.829 43.051,46.9104 z"
       fill="#c0dcfa"
       id="path186" />
    <path
       opacity="0.4"
       d="m 1102.46,220.66 c -0.53,16.726 -14.25,29.837 -30.64,29.291 -0.61,-0.02 -1.21,-0.06 -1.8,-0.12 -0.77,0.03 -1.6,0.04 -2.47,0.015 -1.31,-0.04 -2.63,-0.075 -3.95,-0.11 -30.81,-0.847 -36.69,0.926 -67.493,-0.025 -9.864,-0.306 -16.994,-5.534 -20.94,-14.543 -5.528,-12.204 -0.115,-26.581 12.087,-32.105 2.729,-1.237 5.668,-1.958 8.662,-2.123 3.996,-18.218 20.224,-31.554 39.174,-30.918 13.52,0.496 25.8,8.017 32.39,19.836 2.08,-0.386 4.18,-0.541 6.28,-0.471 16.39,0.551 29.24,14.553 28.7,31.273 z"
       fill="#c0dcfa"
       id="path188" />
  </g>
</svg>
`;

  const encodedSvgData = encodeURIComponent(svgData);

  return (
    <div
      {...generateSectionId(block)}
      className="mx-auto w-full max-w-[1680px] px-6 pt-[20rem] relative overflow-x-hidden bg-center bg-no-repeat sm:px-10 lg:px-20 lg:py-24 2xl:px-[120px]"
      style={{
        backgroundImage: `url("data:image/svg+xml,${encodedSvgData}")`,
      }}
    >
      <div className="flex flex-col lg:flex-row justify-between items-center gap-32">
        <div className="z-[1] w-full lg:w-[28rem] min-w-full lg:min-w-[28rem]">
          <h2 className="font-bold text-brand-ink mb-6">{headline}</h2>
          <p className="mb-10">{copy}</p>
          <ContactForm />
        </div>
        <div className="relative flex-1 self-stretch z-0 max-w-[42rem] min-w-[41rem] hidden lg:block">
          {images.map((image, ix) => (
            <Image
              className={cn('rounded-lg absolute', imageConfigs[ix])}
              key={image._key}
              sanityImage={image}
              sanityRole="presentation"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
